import { methodSteps, trustPoints } from "@/mocks/home";

export default function MethodSection() {
  return (
    <section id="method" className="w-full bg-background-100 py-12 md:py-16">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-2xl mb-8 md:mb-10">
            <span className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium">
              <i className="ri-shield-check-line text-base leading-none"></i>
              分析方法论
            </span>
            <h2 className="mt-2 font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
              一条线索是怎么被确认的
            </h2>
            <p className="mt-3 text-foreground-600 text-sm leading-relaxed">
              固定按六个步骤推进，每一步都留下可回溯的记录，方便你判断某个结论到底站不站得住。
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
            <div className="lg:col-span-2">
              <ol className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
                {methodSteps.map((step) => (
                  <li
                    key={step.id}
                    className="rounded-lg bg-background-50 border border-background-200 p-5"
                  >
                    <span className="font-heading font-black text-primary-500/30 text-3xl">
                      {step.step}
                    </span>
                    <h3 className="mt-1 font-heading font-bold text-foreground-950 text-base">
                      {step.name}
                    </h3>
                    <p className="mt-1.5 text-foreground-600 text-sm leading-relaxed">
                      {step.desc}
                    </p>
                  </li>
                ))}
              </ol>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
                {trustPoints.map((point) => (
                  <div
                    key={point.id}
                    className="rounded-lg bg-accent-50 border border-accent-200 p-4 md:p-5"
                  >
                    <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                      <i className={`${point.icon} text-lg leading-none`}></i>
                    </span>
                    <h4 className="mt-3 font-heading font-semibold text-foreground-950 text-sm">
                      {point.title}
                    </h4>
                    <p className="mt-1 text-foreground-600 text-xs leading-relaxed">
                      {point.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <aside className="flex flex-col gap-5">
              <div className="w-full h-64 md:h-96 rounded-lg overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20a%20video%20analysis%20workspace%2C%20annotated%20printouts%20with%20timecode%20markings%2C%20magnifying%20glass%2C%20headphones%20and%20a%20notebook%20on%20a%20dark%20warm%20wood%20desk%2C%20amber%20desk%20lamp%20glow%2C%20fine%20film%20grain%2C%20editorial%20composition%2C%20no%20text&width=800&height=900&seq=heivideo-method-01&orientation=portrait"
                  alt="逐帧与声音识别分析工作台"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="rounded-lg bg-secondary-500 p-5 md:p-6">
                <h3 className="font-heading font-bold text-background-50 text-lg">
                  三级置信度怎么看
                </h3>
                <ul className="mt-4 flex flex-col gap-3">
                  <li className="flex items-start gap-2.5">
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-background-50 flex-shrink-0"></span>
                    <span className="text-background-50/90 text-sm leading-relaxed">
                      <strong className="font-semibold text-background-50">高置信度</strong>：两个以上
                      维度互相吻合，可稳定复现。
                    </span>
                  </li>
                  <li className="flex items-start gap-2.5">
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-background-50/70 flex-shrink-0"></span>
                    <span className="text-background-50/90 text-sm leading-relaxed">
                      <strong className="font-semibold text-background-50">中等置信度</strong>：单一维度
                      成立，仍缺第二来源佐证。
                    </span>
                  </li>
                  <li className="flex items-start gap-2.5">
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-background-50/40 flex-shrink-0"></span>
                    <span className="text-background-50/90 text-sm leading-relaxed">
                      <strong className="font-semibold text-background-50">待核实</strong>：仅为观察项，
                      可能随新素材变化。
                    </span>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}